import * as React from "react";
import { Login } from "../shared/Login";
import { NavBarContainer } from "./NavBarContainer";

export function SignInPage() {
  return (
    <NavBarContainer variant="marketing">
      <Login />
    </NavBarContainer>
  );
}
